export default "__VITE_ASSET__C4cn6cO___"